import { useDispatch } from 'react-redux';
import newReduxTracker from './reduxTracker';

export default function useReduxTracker() {
  const dispatch = useDispatch();

  return newReduxTracker(dispatch);
}
